import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, take } from 'rxjs';
import { PatientManagerListService } from 'src/patient-manager/services/patient-manager-list.service';

@Component({
    selector: 'app-reset-password-dialog',
    templateUrl: './reset-password-dialog.component.html',
    styleUrls: ['./reset-password-dialog.component.css'],
    standalone: false
})
export class ResetPasswordDialogComponent
{
  currentPatient = this.patientManagerListService.currentPatient
  requestOngoingSubject:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false)


  constructor(private dialogRef: MatDialogRef<any>, private patientManagerListService: PatientManagerListService) { }

  ngOnInit(): void
  {
    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
    {

      this.patientManagerListService.clearPatient()

    })
  }


  exit()
  {
    this.patientManagerListService.clearPatient()
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {

    if (this.currentPatient?.patientId) this.patientManagerListService.resetPatientPassword(this.currentPatient?.patientId).subscribe(l_val=>{
      this.requestOngoingSubject.next(l_val)
    })

  }
}
